"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
var _createEl = require("create-el");
var _cssQuerySelector = _interopRequireDefault(require("css-query-selector"));
var _getStyleTagId = _interopRequireDefault(require("./getStyleTagId.js"));
//@ts-check

/**
 * @param {object} StyleMap
 */
var cleanStyleTag = function cleanStyleTag(StyleMap) {
  (0, _reshowConstant.KEYS)(StyleMap || {}).forEach(function (key) {
    if (StyleMap[key].styleId) {
      var id = (0, _getStyleTagId["default"])(StyleMap[key].styleId);
      var styleDom = _cssQuerySelector["default"].one("#" + id);
      (0, _createEl.remove)(styleDom);
    }
  });
};
var _default = exports["default"] = cleanStyleTag;
module.exports = exports.default;